import React from 'react';
import { RedocStandalone } from 'redoc';

// CUSTOMIZATION : https://redoc.ly/docs/api-reference-docs/configuration/

export default function Redoc({ spec, specUrl }) {
    if (!spec && !specUrl) return null;

    return (
        <div style={{ backgroundColor: "#f0f0f0" }}>
            <RedocStandalone
                specUrl={specUrl}
                spec={spec}
                options={{
                    // nativeScrollbars: true,
                    disableSearch: true,
                    hideDownloadButton: true,
                    pathInMiddlePanel: true,
                    sortEnumValuesAlphabetically: true,
                    // hideLoading: true,
                    theme: {
                        // colors: { primary: { main: '#dd5522' } },
                        rightPanel: {
                            backgroundColor: "#333333",
                        },
                        sidebar: { width: "0px" },
                        // typography: { headings: { lineHeight: "0.5em" } },
                        spacing: { sectionVertical: 1 },

                    },
                }}
            />
        </div>
    )
}
